/**
 * Model pacjenta (zwierzaka) mapujący podstawowe dane z zewnętrznego systemu KlinikiXP.
 * Wykorzystywany jako lekki obiekt zagnieżdżony w większych strukturach.
 */
export class AnimalXp {

  /** Imię pacjenta (zwierzęcia). */
  public aniName: string;

}

/**
 * Model agregujący (DTO) reprezentujący wyniki badań laboratoryjnych
 * w ścisłym powiązaniu z kontekstem historycznej wizyty, klientem oraz pacjentem.
 * Zoptymalizowany pod kątem szybkiego renderowania list i podsumowań w UI.
 */
export class VisitLabTestData {

  /** Globalnie unikalny identyfikator tego konkretnego zestawu wyników. */
  public uuid: string;

  /** Identyfikator powiązanej wizyty w systemie Vetineo. */
  public vetineoVisitUUID: string;

  /** Data odbycia wizyty, na której zlecono/wprowadzono wyniki. */
  public wizDate: string;

  /** Zdenormalizowana nazwa typu wizyty.
   * Pozwala na natychmiastowe wyświetlenie etykiety w UI.
   */
  public typWizName: string;

  /** Zdenormalizowane imię i nazwisko klienta. */
  public clientName: string;

  /** Zagnieżdżony, lekki obiekt reprezentujący badanego pacjenta. */
  public animal: AnimalXp;

  /** Surowy ładunek wyników laboratoryjnych. */
  public labTestData: string;

  /** Gotowe do wyrenderowania w przeglądarce wyniki laboratoryjne. */
  public renderedLabTestData: string;

  /** Zalecenia lekarskie wydane na podstawie tych konkretnych wyników badań. */
  public recommendations: string;

  /** Identyfikator lekarza weterynarii, który zapoznał się z wynikami i je zatwierdził. */
  public labTestDataConfirmedByUserUUID: string;

  /** Data i czas formalnego zatwierdzenia (autoryzacji) wyników w systemie. */
  public labTestDataConfirmed: Date;

  /** Komentarz dodany podczas zatwierdzania wyników. */
  public labTestDataComment: string;

  /** Flaga techniczna określająca, czy w tym obiekcie znajduje się pełen ładunek danych.
   */
  public allData: boolean;

}
